import { render, staticRenderFns } from "./ManagementReceipt.vue?vue&type=template&id=8bfc3676&scoped=true"
import script from "./ManagementReceipt.vue?vue&type=script&lang=js"
export * from "./ManagementReceipt.vue?vue&type=script&lang=js"
import style0 from "./ManagementReceipt.vue?vue&type=style&index=0&id=8bfc3676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfc3676",
  null
  
)

export default component.exports